import { createApp } from 'vue'
import App from './App.vue'
import router from './store/router'
import {Quasar,Meta,Notify, Dialog, Loading} from 'quasar';
import store from './store'
import Observer from 'mobx-vue-lite'
import dataProxy from  '@/store/dbData';
import vso from './store/utils/vso/Main';
import scc from 'socketcluster-client'
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js'

import iconSet from 'https://cdn.jsdelivr.net/npm/quasar@2.17.7/icon-set/fontawesome-v5.js'
import qIt from 'https://cdn.jsdelivr.net/npm/quasar@2.17.7/lang/it.js'
import {get, omit, once, assignIn} from 'lodash';
import VueTelInput from 'vue-tel-input';
import jscookie from 'js-cookie'
//import 'vue-tel-input/dist/vue-tel-input.css';
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'
import { configure, observable } from "mobx"
import {ObjectId} from 'https://cdn.jsdelivr.net/npm/bson/+esm';
window.ObjectId = ObjectId
window.moment.locale('it');
configure({
  enforceActions: "never",
})
let subs = {}

Object.assign(store.state.settings, window.appSettings || {});
const cookieName = `t-${store.state.settings._id}`;

Quasar.lang.set(Quasar.lang.it);
  const app = window.app = createApp(App).use(router).use(store)/* .use(createMetaManager()).use(metaPlugin) */.use(VueTelInput, {
    //mode:"international",
    inputOptions:{
      placeholder:'Recapito telefonico',
    }
  })
.use(Observer).use(VueEasyLightbox)
.use(Quasar,{
  plugins:[Meta , Dialog, Notify, Loading],
  lang:qIt,
  iconSet,
  config: {
    notify:{
      closeBtn:true,
      position: 'bottom',
      textColor: 'white',
      color:'positive',
      timeout:3000
    }
  }
})
.use( new vso(scc.connect({
  hostname: location.hostname,
  port:443,
  secure: true,
  ackTimeout: 10000 ,
  pingInterval: import.meta.env.DEV ? 10_000: 1000,
  autoReconnect: true,
  authEngine:null,
  query:{},
  autoReconnectOptions: {
    initialDelay: 1000, //milliseconds
    randomness: 2000, //milliseconds
    multiplier: 1.5, //decimal
    maxDelay: 4000 //milliseconds
  },
}), store));

app.config.globalProperties.$dbData = dataProxy;
app.component('myloading', {
  template: `<h1>CARICAMENTO</h1>`
});

(async ()=>{
  app.config.globalProperties.login = ()=>new Promise( r =>{
    let t =  jscookie.get(cookieName);
    if (!t) return r();
    app.config.globalProperties.$socket.emit('tokenLogin',{t  },async (err, data)=>{
      
      if (err) {
        if (err === 'nodevice') {
          app.config.globalProperties.$q.notify({
            position: 'center',
            textColor: 'white',
            color:'negative',
            message: `Dispositivo disconnesso`,
            
          });
          jscookie.remove(cookieName)
          window.location.href = `https://${store.state.wshost}/login`;
        }
        if (err === 'loggedSomewhereElse') {
          app.config.globalProperties.$q.notify({
            position: 'center',
            textColor: 'white',
            color:'negative',
            message: `É stato effettuato l' accesso su un altro dispositivo.`,
            
          });
          jscookie.remove(cookieName)
          window.location.href = `https://${pstore.state.wshost}/login`;
        }
        if (err == 'no ex' || err == 'no - logout' ) {
          jscookie.remove(cookieName)
          console.error(err);
          if (!window.location.pathname.startsWith('/login'))
            window.location.href = '/login';
          /* if (!window.location.pathname.startsWith('/login'))
          window.location.href = '/login' */
        }
        Object.assign(store.state.usr , { _id : null });
        r(false);
        
        return;
      }
      if (data.uu) {
        store.state.uu = data.uu;
      }
      if (data?.u) {
        let {u} = data;
        Object.assign( store.state.usr , u);
        r(1);
        login({u,t});
        if (!app.config.globalProperties.$authToken.deviceName) {
          subs.usrChannel = app.config.globalProperties.$socket.subscribe(`i/${u._id}`)
          subs.usrChannel.watch(data=>{
            if (data.type === 'logout')
              app.config.globalProperties.$q.dialog({
              title:`Ti sei loggato dall'indirizzo ip ${data.ip}`
            }).onDismiss(()=>{
              app.config.globalProperties.$store.commit('logout')
            })
          })
        }
        
      }
      else r(false);
      
    })
  });
  
  await Promise.all([
    app.config.globalProperties.login(),
    app.config.globalProperties.$router.isReady()
  ])
  window.ss.value.dataLoaded = true;
  const guard =  (to:any /* , from */ ) => {
    const canAccess = get(app,'config.globalProperties.$authToken._id',false);
    let isAccessiblePath = (['/login','/optin','/resetPwd','/registrazione']).find(p=>to.path?.startsWith(p))
    console.log('guard',!canAccess,!isAccessiblePath)
    if (!canAccess && !isAccessiblePath) return '/login';
  };
  
  router.beforeEach(guard);
  let to =  guard(app.config.globalProperties.$route);
  if (to)
    app.config.globalProperties.$router.replace('/login');
  
  app.mount('#app');
  
  
  if ('serviceWorker' in navigator && 'PushManager' in window) {    
    const swReg = await navigator.serviceWorker.register('/public/sw.js?updated='+import.meta.env.BUILD_TIME).catch(e=>console.error(e));
    console.log('swred', swReg)
    if (!swReg) return;
    const applicationServerKey = urlB64ToUint8Array(import.meta.env.VITE_WEBPUSH_PUBLIC_KEY);
    const push = await swReg.pushManager.subscribe({userVisibleOnly: true,applicationServerKey: applicationServerKey})
    console.log('push',push)
    push && app.config.globalProperties.$socket.emit('registerWebPush',push);
  } else {
    console.warn('Push messaging is not supported');
  }  
  
  
})().catch(e=>{
  console.error('mount error', e)
});

const login = once(async({})=>{
  app.config.globalProperties.$socket.on('dbData',(data)=>{
    
    console.log('dbData', data )
    assignIn(window.ss.value.users, data.usr||{})
    assignIn(window.ss.value.docs, data.docs||{})

  });
  app.config.globalProperties.$socket.subscribe('usr', {waitForAuth: true}).watch(({u})=>{
    const {usr} = store.state;
    if (usr._id == u._id)
      Object.assign(store.state.usr, omit(u,  (usr.org?._id && usr.org?._id != u._id) ? ['forms','devices'] : []))
    else 
      window.ss.value.users[u._id] = u
  });
  app.config.globalProperties.$socket.subscribe('informative', {waitForAuth: true}).watch(({i})=>{
    console.log('channel informative', i)
    store.state.usr.informative[i._id] = i
  });
  app.config.globalProperties.$socket.subscribe('comunicazioni', { waitForAuth: true}).watch(({c})=>{
    store.state.comunicazioni[c._id] = c
  });
  app.config.globalProperties.$socket.subscribe('docs', { waitForAuth: true}).watch(({d})=>{
    window.ss.value.docs[d._id] = d
  });
  
  /*     (async ()=>{
  subs.usr = window.m.collection('usr').watch({ids:[u._id]});
  for await (const c of subs.usr) {
  console.log('change usr!',c);
  Object.assign(store.state.usr, omit(c.fullDocument,  (u.org?._id && u.org?._id != u._id) ? ['forms','devices'] : []))
  }
  })();
  */
})

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
  .replace(/-/g, '+')
  .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
window.testMail= (str)=>{
  return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(str.trim().toLowerCase())
}